




































import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'LegalWaiverModal',
  props: {
    waiver: {
      type: Object,
    },
    showCloseButton: {
      type: Boolean,
    },
    uuid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isScrolledToBottom: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters('studio', ['currentStudioId']),
  },
  methods: {
    async signWaiver() {
      this.isLoading = true;
      try {
        const dispatchPromise = await this.$store.dispatch('user/signWaiver', {
          studio_id: this.currentStudioId,
          waiver_id: this.waiver?.id,
          uuid: this.uuid,
        });
        await this.$store.dispatch(
          'studio/getStudio',
          getStudioURL(this.$route)
        );
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('WAIVER.NOTIFICATIONS.SIGN_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('WAIVER.NOTIFICATIONS.SIGN_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
    checkIfScrollToBottom({
      target: { scrollTop, clientHeight, scrollHeight },
    }) {
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isScrolledToBottom = true;
      }
    },
  },
  mounted() {
    this.checkIfScrollToBottom({ target: this.$refs.waiverContent.$el });
  },
});
